module.exports = __webpack_public_path__ + "img/prize-fsc-dark.5a1bf5b3.png";